import { LG, MD, SM } from '@utils/imageutils';
import classNames from 'classnames';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProductTile from '@moncler/components/listing/ProductTile';
import ProductImage from '../product/ProductImage';
import analytics from '@common/utils/analytics';
const useWindowSize = () => {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
};
// prodotto usato per test vale https://dev12.cdn.moncler.ows.farm/en-us/outerwear/down-jackets-daniel-G10911A1090053279999.html
const ProductLook = (props) => {
    const { t } = useTranslation();
    const { look } = props;
    const lookImage = useRef();
    const [lookImageHeight, setLookImageHeight] = useState(0);
    const [width] = useWindowSize();
    useEffect(() => {
        if (lookImage.current) {
            setTimeout(() => {
                setLookImageHeight(lookImage.current.offsetHeight);
            }, 100);
        }
    }, [width]);
    useEffect(() => {
        var _a;
        ((_a = look === null || look === void 0 ? void 0 : look.products) === null || _a === void 0 ? void 0 : _a.length) > 0 && analytics.productImpressionsRecommended(look.products, 'shop_the_look_pdp');
    }, [look]);
    return (React.createElement(React.Fragment, null, look.products.length >= 1 && (React.createElement("div", { className: "container product-look" },
        React.createElement("div", { className: "row justify-center" },
            React.createElement("div", { className: "col-sm-8 col-md-12" },
                React.createElement("h2", { className: "product-look__title" }, t('label.shopthelook')),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-3 offset-md-1 offset-xl-2" },
                        React.createElement("div", { ref: lookImage, className: classNames('product-look__image', { 'd-none d-md-block': look.hideLookImage }), style: { '--card-height': lookImageHeight + 'px' } },
                            React.createElement(ProductImage, { tiletype: "ProductLook", img: props.product.imgs, type: 'X', sizes: [SM, MD, LG] }))),
                    React.createElement("div", { className: "col-md-6 offset-md-1 col-xl-4 product-look__column" },
                        React.createElement("ul", { className: "row" }, look.products.map((product, i) => (React.createElement("li", { className: "col-6 product-look__tile", key: i },
                            React.createElement(ProductTile, { product: product, type: "LOOKPRODUCT", forceStillLifeImage: true, index: i, hideWishlistBtn: true, noSwatch: true })))))))))))));
};
export default ProductLook;
